"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPlanManager__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "planId",
                type: "uint256",
            },
        ],
        name: "getPlan",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "indexer",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "templateId",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "deploymentId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bool",
                        name: "active",
                        type: "bool",
                    },
                ],
                internalType: "struct Plan",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "templateId",
                type: "uint256",
            },
        ],
        name: "getPlanTemplate",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "period",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "dailyReqCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rateLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "metadata",
                        type: "bytes32",
                    },
                    {
                        internalType: "bool",
                        name: "active",
                        type: "bool",
                    },
                ],
                internalType: "struct PlanTemplate",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class IPlanManager__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IPlanManager__factory = IPlanManager__factory;
IPlanManager__factory.abi = _abi;
